import React from "react";
import i18n from "../../i18n/config";
import { Trait } from "./Services/BabyPeekService";

export const babyPeekTraitLabelKeyByTrait: Record<Trait, string> = {
  Asparagus: "babyPeek.traits.labels.asparagusOdorDetection",
  BabyTeeth: "babyPeek.traits.labels.teethingTimeline",
  Bitter: "babyPeek.traits.labels.bitterTaste",
  Cilantro: "babyPeek.traits.labels.cilantroAversion",
  CurlyHair: "babyPeek.traits.labels.hairTexture",
  EyeColor: "babyPeek.traits.labels.eyeColor",
  Freckle: "babyPeek.traits.labels.freckles",
  HairThickness: "babyPeek.traits.labels.hairThickness",
  LightOrDarkHair: "babyPeek.traits.labels.lightOrDarkHair",
  RedHair: "babyPeek.traits.labels.redHair",
  Sweet: "babyPeek.traits.labels.sweetTaste",
  SweetSalty: "babyPeek.traits.labels.sweetVsSalty",
};

export const babyPeekTraitLabelKeyByUrl: Record<string, string> = {
  asparagus: babyPeekTraitLabelKeyByTrait.Asparagus,
  babyteeth: babyPeekTraitLabelKeyByTrait.BabyTeeth,
  bitter: babyPeekTraitLabelKeyByTrait.Bitter,
  cilantro: babyPeekTraitLabelKeyByTrait.Cilantro,
  curlyhair: babyPeekTraitLabelKeyByTrait.CurlyHair,
  eyecolor: babyPeekTraitLabelKeyByTrait.EyeColor,
  freckle: babyPeekTraitLabelKeyByTrait.Freckle,
  hairthickness: babyPeekTraitLabelKeyByTrait.HairThickness,
  lightordarkhair: babyPeekTraitLabelKeyByTrait.LightOrDarkHair,
  redhair: babyPeekTraitLabelKeyByTrait.RedHair,
  sweet: babyPeekTraitLabelKeyByTrait.Sweet,
  sweetsalty: babyPeekTraitLabelKeyByTrait.SweetSalty,
};

export const babyPeekTraitSummaryLabelKeyByUrl: Record<string, string> = {
  asparagus: "babyPeek.traits.summaryLabels.asparagus",
  babyteeth: "babyPeek.traits.summaryLabels.babyteeth",
  bitter: "babyPeek.traits.summaryLabels.bitter",
  cilantro: "babyPeek.traits.summaryLabels.cilantro",
  curlyhair: "babyPeek.traits.summaryLabels.curlyhair",
  eyecolor: "babyPeek.traits.summaryLabels.eyecolor",
  freckle: "babyPeek.traits.summaryLabels.freckle",
  hairthickness: "babyPeek.traits.summaryLabels.hairthickness",
  lightordarkhair: "babyPeek.traits.summaryLabels.lightordarkhair",
  redhair: "babyPeek.traits.summaryLabels.redhair",
  sweet: "babyPeek.traits.summaryLabels.sweet",
  sweetsalty: "babyPeek.traits.summaryLabels.sweetsalty",
};

export const getBabyPeekTraitLabel = (trait: Trait): string =>
  getBabyPeekText(babyPeekTraitLabelKeyByTrait[trait]);

export const getBabyPeekText = (key: string): string => {
  const value = i18n.getResource(i18n.language, "translation", key);
  if (typeof value === "string") {
    return value;
  }

  const fallbackValue = i18n.getResource("en", "translation", key);
  return typeof fallbackValue === "string" ? fallbackValue : key;
};

export const BabyPeekTraitLabel: React.FC<{ trait: Trait }> = ({ trait }) => (
  <>{getBabyPeekTraitLabel(trait)}</>
);
